<div class="close-container">
    <img src="../assets/download_icon.png" (click)="onDownload()" class="download" role="button" tabindex="0" aria-label="Download PDF" alt="Download PDF" (keydown.enter)="onDownload()" (keydown.space)="$event.preventDefault(); onDownload()" />
    <img src="../assets/close_icon.svg" (click)="onClickClose()" class="close" role="button" tabindex="0" aria-label="Close" alt="Close" (keydown.enter)="onClickClose()" (keydown.space)="$event.preventDefault(); onClickClose()" />
  </div>
  <div class="viewReport" [innerHTML]="viewReport | safeHtml" id="view_invoice_report">
  
  </div>
